module.exports = __webpack_public_path__ + "static/img/nav-bg.4431b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/nav-bg.png
// module id = Mr5Z
// module chunks = 33